import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import dayjs from "dayjs";
import Head from "next/head";
import Navbar from "../../../components/_App/Navbar1";
import PageBanner from "../../../components/Common/PageBanner";
import Link from "next/link";
import Footer from "../../../components/_App/Footer";
import BlogSidebar from "../../../components/Blog/BlogSidebar";
import style from "../markdown-styles.module.css";
import dynamic from "next/dynamic";
import useWindowSize from "../../../hooks/useWindowSize";
import { convertToImageKit } from "../../../utils/convert-to-imagekit";
import LazyLoad from "react-lazyload";
// import Image from "next/image";
import styles from "./[slug].module.scss";
import { BASE_URL } from "../../../constants";
import Modal from "../../../components/products/Modal";
import { PlayIcon } from "@heroicons/react/outline";
import { MdCall } from "react-icons/md";

// import { LCPDivisons } from "../../../utils/lcp";

const ModalVideo = dynamic(() => import("react-modal-video"), {
  ssr: false,
});
// import CommentArea from "../components/Blog/CommentForm";

const BlogDetails = ({ detailedBlog, dataNav, banner }) => {
  const size = useWindowSize();
  const [tabUrl, setTabUrl] = useState(null);
  const [language, setLanguage] = useState("en");
  const [isOpen, setIsOpen] = React.useState(true);
  const [startVideo, setStartVideo] = useState(null);
  const [endVideo, setEndVideo] = useState(null);

  const openModal = () => {
    setIsOpen(!isOpen);
  };

  const eng = "en";
  const hi = "hi";

  useEffect(() => {
    setTabUrl(window.location.href);
  }, []);

  const videoPath =
    detailedBlog &&
    detailedBlog.feed &&
    detailedBlog.feed.link &&
    detailedBlog.feed.link.split("/");

  const blogStartVideo = () => {
    const startVideo = detailedBlog.feed.link_start_time
      .split(":")
      .reduce((acc, time) => 60 * acc + +time);
    setStartVideo(startVideo);
  };
  useEffect(() => {
    blogStartVideo();
  }, []);

  const blogEndVideo = () => {
    const endVideo = detailedBlog.feed.link_end_time
      .split(":")
      .reduce((acc, time) => 60 * acc + +time);
    setEndVideo(endVideo);
  };
  useEffect(() => {
    blogEndVideo();
  }, []);

  const myLoader = ({ src, width }) => {
    return src + `?tr=w-${size.width}`;
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Article",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": `${BASE_URL}/current-affairs/blog/${detailedBlog.feed.slug}`,
    },
    headline: detailedBlog.feed.head,
    description: detailedBlog.feed.content,
    image: detailedBlog.feed.image,
    author: {
      "@type": "Organization",
      name: "ToppersNotes",
      url: "https://web.toppersnotes.com",
    },
    publisher: {
      "@type": "Organization",
      name: "ToppersNotes",
      logo: {
        "@type": "ImageObject",
        url: "https://toppersnotes-web.s3.ap-south-1.amazonaws.com/Gallery/Thumbnails/tn-logo-header.png",
      },
    },
    datePublished: dayjs(detailedBlog.feed.updated_at).format("YYYY-MM-DD"),
  };

  const [showModal, setShowModal] = React.useState(false);

  useEffect(() => {
    setTimeout(() => {
      //check from db
      if (detailedBlog.feed.lead_modal_open == 1) {
        setShowModal(true);
      }
    }, 5000);
  }, []);

  return (
    <React.Fragment>
      <Navbar data={dataNav} />
      <PageBanner
        pageTitle={detailedBlog && detailedBlog.feed && detailedBlog.feed.head}
        homePageUrl="/"
        homePageText="Home"
        activePageText={
          detailedBlog &&
          detailedBlog.paths.map((path, index) => {
            const i = detailedBlog.paths.length - 1;
            return (
              <>
                {index == 0 ? (
                  <Link href="/current-affairs/">
                    <a>{path.name}</a>
                  </Link>
                ) : index == 1 ? (
                  <Link href="/current-affairs/english-current-affair">
                    <a>{path.name}</a>
                  </Link>
                ) : index == 2 ? (
                  <Link
                    href={`/current-affairs/english-current-affair/${path.slug}`}
                  >
                    <a>{path.name}</a>
                  </Link>
                ) : (
                  <Link
                    href={`/current-affairs/english-current-affair/date/${path.slug}`}
                  >
                    <a>{path.name}</a>
                  </Link>
                )}
                {index !== i && " / "}
              </>
            );
          })
        }
      />
      <div>
        <Head>
          <link
            href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css"
            rel="stylesheet"
            integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC"
            crossorigin="anonymous"
          ></link>
          <title>{detailedBlog.feed && detailedBlog.feed.head}</title>
          <meta
            name="viewport"
            content="initial-scale=1.0, width=device-width"
          />
          <meta property="og:title" content={detailedBlog.feed.head} />
          <meta
            name="description"
            content={
              detailedBlog &&
              detailedBlog.feed.content &&
              detailedBlog.feed.content.slice(0, 170).replace("*", "")
            }
          />
          <meta
            property="og:description"
            content={
              detailedBlog &&
              detailedBlog.feed.content &&
              detailedBlog.feed.content.slice(0, 170).replace("*", "")
            }
          />
          <meta property="og:image" content={detailedBlog.feed.image} />
          <meta property="og:type" content="website" />
          <meta property="og:url" content={tabUrl} />
          <link
            rel="canonical"
            // property="og:description"
            // content={detailedBlog.feed.content}
            // key="description"
            href={tabUrl}
          ></link>
          <link
            rel="preload"
            as="image"
            imagesrcset={convertToImageKit(detailedBlog.feed.image, "app")}
          ></link>
          <link rel="dns-prefetch" href="https://api.toppersnotes.com"></link>
          <link
            rel="dns-prefetch"
            href="https://s3.ap-south-1.amazonaws.com"
          ></link>
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
          />
        </Head>
      </div>
      {showModal && (
        <Modal
          productExamId={"4"}
          page="current_affairs"
          showModal={showModal}
          setShowModal={setShowModal}
          lang="en"
        />
      )}
      <div
      //  className={styles["ptb-100"]}
      >
        <div className={styles.container}>
          {/* <div className="container"> */}
          <div className="row">
            {detailedBlog && detailedBlog.feed ? (
              <>
                <div className="col-lg-8 col-md-12">
                  <div className={styles["blog-details-desc"]}>
                    <div className="col-lg-12 col-md-12">
                      <div
                        // className="about-video-box"
                        className={styles["about-video-box"]}
                      >
                        <div className={styles["image"]}>
                          {/* <div className="article-image"> */}
                          {/* <img
                            src={detailedBlog.feed.image}
                            alt={detailedBlog.feed.head}
                            width="100%"
                          /> */}
                          <LazyLoad once>
                            {/* <Image
                              unoptimized={true}
                              loader={myLoader}
                              width={800}
                              height={540}
                              src={convertToImageKit(
                                detailedBlog.feed.image,
                                "app"
                              )}
                              alt={detailedBlog.feed.head}
                              priority={true}
                            /> */}
                            <img
                              width={800}
                              height={540}
                              src={convertToImageKit(
                                detailedBlog.feed.image,
                                "app"
                              )}
                              alt={detailedBlog.feed.head}
                            />
                          </LazyLoad>
                        </div>
                        {/* </div> */}
                        {detailedBlog.feed.link && (
                          <Link href="#play-video">
                            <a
                              onClick={(e) => {
                                e.preventDefault();
                                openModal();
                              }}
                              // className="video-btn popup-youtube"
                              className={`${styles["video-btn"]} popup-youtube`}
                            >
                              <PlayIcon />
                              {/* <i className="flaticon-play"></i> */}
                            </a>
                          </Link>
                        )}
                      </div>
                    </div>
                    <div className="mt-4">
                      <span
                        onClick={() => {
                          setShowModal(true);
                        }}
                        className="flex flex-row items-center justify-center gap-2 py-2.5 hover:opacity-90 bg-[#f5f3ff] text-tn-purple font-semibold text-center rounded-lg cursor-pointer border border-[1px] border-tn-purple"
                      >
                        <MdCall size={20} /> Contact Counsellor
                      </span>
                    </div>
                    <div className={styles["article-content"]}>
                      <div className={styles["entry-meta"]}>
                        <ul className="flex flex-col md:flex-row justify-between">
                          <div className="flex justify-center">
                            <li>
                              <i className="bx bx-folder-open"></i>
                              <span>Category</span>
                              {detailedBlog &&
                                detailedBlog.feed &&
                                detailedBlog.feed.tags.map((t_name, index) => {
                                  const i = detailedBlog.feed.tags.length - 1;
                                  return (
                                    <>
                                      <Link href={`/blog/${t_name.slug}`}>
                                        <a>{t_name.name}</a>
                                      </Link>
                                      {index !== i && ", "}
                                    </>
                                  );
                                })}
                            </li>
                            <li>
                              <i className="bx bx-calendar"></i>
                              <span>Last Updated</span>
                              <Link href="#">
                                <a>
                                  {dayjs(detailedBlog.feed.date).format(
                                    "DD/MM/YYYY"
                                  )}
                                </a>
                              </Link>
                            </li>
                          </div>

                          <li className={`!flex ${styles.hindiEnglish}`}>
                            <div className="bg-gray-200 rounded-lg p-1 flex justify-between h-12 w32">
                              <div
                                style={{
                                  color: "white",
                                  backgroundColor: " rgb(105, 78, 237)",
                                  borderRadius: "5px",
                                }}
                                className="rounded-lg h-full w-full"
                              >
                                <input
                                  type="radio"
                                  name="room_type"
                                  id="roomPrivate"
                                  checked
                                  hidden
                                />
                                <Link
                                  href={`/current-affairs/blog/${detailedBlog.feed.slug}`}
                                >
                                  <label
                                    onClick={() => setLanguage(eng)}
                                    for="roomPrivate"
                                    className="!px-11 !py-2 radio text-center self-center py-2 px-4 rounded-lg cursor-pointer hover:opacity-75"
                                  >
                                    English
                                  </label>
                                </Link>
                              </div>
                              <div className=" rounded-lg h-full w-full">
                                <input
                                  type="radio"
                                  name="room_type"
                                  id="roomPublic"
                                  hidden
                                />
                                <Link
                                  href={`/current-affairs/blog/hindi/${detailedBlog.feed.slug}`}
                                >
                                  <label
                                    onClick={() => setLanguage(hi)}
                                    for="roomPublic"
                                    className="!px-11 !py-2 radio text-center self-center py-2 px-4 rounded-lg cursor-pointer hover:opacity-75"
                                  >
                                    Hindi
                                  </label>
                                </Link>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>

                      {banner &&
                        banner.length &&
                        banner.map((banner_data) => {
                          return (
                            <>
                              {banner_data && banner_data.position === "top" ? (
                                <>
                                  <Link href={banner_data && banner_data.link}>
                                    <a>
                                      <div
                                        className={`${styles["image-banner"]} bg-inherit bg-center rounded-md shadow mt-4 flex justify-center items-center`}
                                      >
                                        {/* <img
                                          className="h-full w-full object-fill p-3 rounded-md"
                                          src={banner_data && banner_data.image}
                                          alt={banner_data && banner_data.name}
                                        /> */}
                                        <div
                                          style={{
                                            padding: "0.8rem",
                                            paddingBottom: "0.5rem",
                                          }}
                                        >
                                          <LazyLoad once>
                                            {/* <Image
                                              unoptimized={true}
                                              loader={myLoader}
                                              width={800}
                                              height={110}
                                              src={convertToImageKit(
                                                banner_data.image,
                                                "app"
                                              )}
                                              alt={banner_data.name}
                                              priority={true}
                                            /> */}
                                            <img
                                              width={800}
                                              height={110}
                                              src={convertToImageKit(
                                                banner_data.image,
                                                "app"
                                              )}
                                              alt={banner_data.name}
                                            />
                                          </LazyLoad>
                                        </div>
                                      </div>
                                    </a>
                                  </Link>
                                </>
                              ) : (
                                ""
                              )}
                            </>
                          );
                        })}

                      {/* <h3>It’s Time To Think Differently About Homeschooling</h3> */}
                      <h3>{detailedBlog.feed.head}</h3>
                      {/* <p>{detailedBlog.feed.content}</p> */}
                      <ReactMarkdown
                        plugins={[[remarkGfm, { singleTilde: false }]]}
                        children={detailedBlog.feed.content}
                        className={style.reactMarkDown}
                      />
                      {/* <blockquote className="wp-block-quote">
                  <ReactMarkdown>{detailedBlog.feed.head}</ReactMarkdown>

                    <cite>Tom Cruise</cite>
                  </blockquote> */}
                      {detailedBlog &&
                        detailedBlog.feed.pages &&
                        detailedBlog.feed.pages.map((blog, index) => {
                          return (
                            <>
                              {index === 1 &&
                                banner &&
                                banner.length &&
                                banner.map((banner_data) => {
                                  return (
                                    <>
                                      {banner_data &&
                                      banner_data.position &&
                                      banner_data.position === "in-content" ? (
                                        <>
                                          <Link
                                            href={
                                              banner_data && banner_data.link
                                            }
                                          >
                                            <a>
                                              <div
                                                className={`${styles["image-banner"]} bg-inherit bg-center rounded-md shadow mt-4 flex justify-center items-center`}
                                              >
                                                {/* <img
                                                  className="h-full w-full object-fill p-3 rounded-md"
                                                  src={
                                                    banner_data &&
                                                    banner_data.image
                                                  }
                                                  alt={
                                                    banner_data &&
                                                    banner_data.name
                                                  }
                                                /> */}
                                                <div
                                                  style={{
                                                    padding: "0.8rem",
                                                    paddingBottom: "0.5rem",
                                                  }}
                                                >
                                                  <LazyLoad once>
                                                    {/* <Image
                                                      unoptimized={true}
                                                      loader={myLoader}
                                                      width={800}
                                                      height={105}
                                                      src={convertToImageKit(
                                                        banner_data.image,
                                                        "app"
                                                      )}
                                                      alt={banner_data.name}
                                                      priority={true}
                                                    /> */}
                                                    <img
                                                      width={800}
                                                      height={105}
                                                      src={convertToImageKit(
                                                        banner_data.image,
                                                        "app"
                                                      )}
                                                      alt={banner_data.name}
                                                    />
                                                  </LazyLoad>
                                                </div>
                                              </div>
                                            </a>
                                          </Link>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                    </>
                                  );
                                })}
                              <ReactMarkdown
                                children={blog.content}
                                remarkPlugins={[remarkGfm]}
                                className={style.reactMarkDown}
                              />
                            </>
                          );
                        })}

                      <>
                        {banner &&
                          banner.length &&
                          banner.map((banner_data) => {
                            return (
                              <>
                                {banner_data &&
                                banner_data.position === "bottom" ? (
                                  <>
                                    <Link
                                      href={banner_data && banner_data.link}
                                    >
                                      <a>
                                        <div
                                          className={`${styles["image-banner"]} bg-inherit bg-center rounded-md shadow mt-4 flex justify-center items-center`}
                                        >
                                          {/* <img
                                            className="h-full w-full object-fill p-3 rounded-md"
                                            src={
                                              banner_data && banner_data.image
                                            }
                                            alt={
                                              banner_data && banner_data.name
                                            }
                                          /> */}
                                          <div
                                            style={{
                                              padding: "0.8rem",
                                              paddingBottom: "0.5rem",
                                            }}
                                          >
                                            <LazyLoad once>
                                              {/* <Image
                                                unoptimized={true}
                                                loader={myLoader}
                                                width={800}
                                                height={130}
                                                src={convertToImageKit(
                                                  banner_data.image,
                                                  "app"
                                                )}
                                                alt={banner_data.name}
                                                priority={true}
                                              /> */}
                                              <img
                                                width={800}
                                                height={130}
                                                src={convertToImageKit(
                                                  banner_data.image,
                                                  "app"
                                                )}
                                                alt={banner_data.name}
                                              />
                                            </LazyLoad>
                                          </div>
                                        </div>
                                      </a>
                                    </Link>
                                  </>
                                ) : (
                                  ""
                                )}
                              </>
                            );
                          })}
                      </>

                      {/* <ul className="wp-block-gallery columns-3"> */}
                      {/* {detailedBlog &&
                      detailedBlog.latest_feeds.map((l_Feed) => (
                        <li className="blocks-gallery-item">
                          <Link href={`./${l_Feed.slug}`}>
                            <a className="link-btn">
                              <figure>
                                <img src={l_Feed.image} alt="image" />
                              </figure>
                            </a>
                          </Link>
                        </li>
                      ))} */}

                      {/* <li className="blocks-gallery-item">
                          <figure>
                            <img src="/images/blog/blog14.jpg" alt="image" />
                          </figure>
                        </li>
                        <li className="blocks-gallery-item">
                          <figure>
                            <img src="/images/blog/blog13.jpg" alt="image" />
                          </figure>
                        </li> */}
                      {/* </ul> */}

                      {/* <h3>Four major elements that we offer:</h3>

                  <ul className="features-list">
                    <li>
                      <i className="bx bx-badge-check"></i> Scientific skills
                      for getting a better result
                    </li>
                    <li>
                      <i className="bx bx-badge-check"></i> Communication skills
                      to getting in touch
                    </li>
                    <li>
                      <i className="bx bx-badge-check"></i> A career overview
                      opportunity available
                    </li>
                    <li>
                      <i className="bx bx-badge-check"></i> A good work
                      environment for work
                    </li>
                  </ul> */}

                      {/* <h3>Setting the mood with incense</h3>
                      <ReactMarkdown>{blog.content}</ReactMarkdown> */}

                      {/* <h3>The rise of marketing and why you need it</h3>
                          <p>{blog.content}</p> */}
                    </div>

                    {/* <div className="article-footer">
                  <div className="article-tags">
                    <span>
                      <i className="bx bx-purchase-tag"></i>
                    </span>

                    <a href="#">Fashion</a>
                    <a href="#">Games</a>
                    <a href="#">Travel</a>
                  </div>

                  <div className="article-share">
                    <ul className="social">
                      <li>
                        <span>Share:</span>
                      </li>
                      <li>
                        <a href="#" className="facebook" target="_blank">
                          <i className="bx bxl-facebook"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#" className="twitter" target="_blank">
                          <i className="bx bxl-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#" className="linkedin" target="_blank">
                          <i className="bx bxl-linkedin"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#" className="instagram" target="_blank">
                          <i className="bx bxl-instagram"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div> */}

                    {/* <div className="edemy-post-navigation">
                  <div className="prev-link-wrapper">
                    <div className="info-prev-link-wrapper">
                      <a href="#">
                        <span className="image-prev">
                          <img src="/images/blog/blog11.jpg" alt="image" />
                          <span className="post-nav-title">Prev</span>
                        </span>

                        <span className="prev-link-info-wrapper">
                          <span className="prev-title">
                            What Is The MLB Summer Slugger Program?
                          </span>
                          <span className="meta-wrapper">
                            <span className="date-post">January 21, 2020</span>
                          </span>
                        </span>
                      </a>
                    </div>
                  </div>

                  <div className="next-link-wrapper">
                    <div className="info-next-link-wrapper">
                      <a href="#">
                        <span className="next-link-info-wrapper">
                          <span className="next-title">
                            28 Student-Centered Instructional Strategies
                          </span>
                          <span className="meta-wrapper">
                            <span className="date-post">January 19, 2020</span>
                          </span>
                        </span>

                        <span className="image-next">
                          <img src="/images/blog/blog12.jpg" alt="image" />
                          <span className="post-nav-title">Next</span>
                        </span>
                      </a>
                    </div>
                  </div>
                </div> */}

                    {/* <CommentArea /> */}
                  </div>
                </div>
              </>
            ) : (
              "Invalid Response"
            )}

            <div className="col-lg-4 col-md-12">
              <BlogSidebar language={language} />
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <ModalVideo
        channel="youtube"
        youtube={{ start: startVideo, end: endVideo, autoplay: 1 }}
        // autoplay={1}
        // mute={1}
        // enablejsapi={1}
        isOpen={!isOpen}
        videoId={videoPath && videoPath[videoPath && videoPath.length - 1]}
        // start={startVideo}
        // end={endVideo}
        onClose={() => setIsOpen(!isOpen)}
        // start={
        //   detailedBlog && detailedBlog.feed && detailedBlog.feed.link_start_time
        // }
      />
    </React.Fragment>
  );
};

export const getStaticPaths = async () => {
  // const res = await fetch(
  //   `https://api.toppersnotes.com/api/ca/get-offering-feed-slugs?offering_slug=english-current-affairs`
  // );
  // const directories = await res.json();

  // const paths = directories.slugs.map((directory) => ({
  //   params: { slug: directory.toString() },
  // }));

  return {
    paths: [],
    fallback: "blocking",
  };
};

export const getStaticProps = async (context) => {
  const slug = context.params.slug;
  const lang = "en";

  const res = await fetch(
    `https://api.toppersnotes.com/api/ca/article-by-slug?slug=${slug}&lang=${lang}`
  );

  const detailedBlog = await res.json();

  const url = `https://api.toppersnotes.com/api/ca/get/banners?type=blog&lang=en`;

  let data = await fetch(url);
  let parsedData = await data.json();

  if (!detailedBlog) {
    return {
      notFound: true,
    };
  }
  return {
    props: { detailedBlog, banner: parsedData },
    revalidate: 86400,
  };
};

export default BlogDetails;
